import type { DataComponentType, MarketsComponentType } from '../types';

type LooseComponent = DataComponentType & Record<string, unknown>;
type LooseTab = Record<string, unknown> & {
  id?: string;
  layout?: DataComponentType['layout'];
  name?: string | null;
};

const normalizeTab = (tab: LooseTab, layout: DataComponentType['layout'] | undefined) => ({
  ...tab,
  id: tab.id ?? crypto.randomUUID(),
  name: tab.name ?? '',
  layout: tab.layout ?? layout
});

export const parseMarketComponent = (
  component: DataComponentType,
  version = '1'
): MarketsComponentType => {
  const temp = { ...(component as LooseComponent) };

  const tabs = temp.tabs;
  const id = crypto.randomUUID();

  if (temp.type === 'tabcontainer' && Array.isArray(tabs)) {
    return {
      layout: component.layout,
      tabs: tabs.map(tab =>
        normalizeTab(tab as LooseTab, component.layout)
      ) as MarketsComponentType['tabs'],
      id
    };
  }

  if (version === '1') {
    if (temp.type === 'feed') {
      return {
        layout: component.layout,
        tabs: [{ name: 'Feed', ...component }] as MarketsComponentType['tabs'],
        id: crypto.randomUUID()
      };
    }
    if (temp.type === 'file_list') {
      return {
        layout: component.layout,
        tabs: [{ ...temp, name: temp.name ?? 'Data lake files' }],
        id
      };
    }
    if (Array.isArray(tabs)) {
      const tt = tabs.map(item => {
        return { ...item, ...component };
      });

      return { layout: component.layout, tabs: tt, id: crypto.randomUUID() };
    }
  }

  if (temp.type === 'tiles') {
    return {
      layout: component.layout,
      component: normalizeTab(temp, component.layout) as MarketsComponentType['component'],
      id: crypto.randomUUID()
    };
  }

  if (Array.isArray(tabs)) {
    return {
      layout: component.layout,
      tabs: tabs.map(tab =>
        normalizeTab(tab as LooseTab, component.layout)
      ) as MarketsComponentType['tabs'],
      id
    };
  }

  // When tabs are not present,
  return {
    layout: component.layout,
    tabs: [normalizeTab(temp, component.layout)] as MarketsComponentType['tabs'],
    id
  };
};
